import { getMerchantGeneralSettings } from 'APIs/merchants/merchants';
import { MerchantGeneralSettingsResponse } from 'APIs/merchants/merchants.types';
import HeaderTile from 'Components/HeaderTitle/HeaderTitle';
import Message from 'Components/Message';
import Spinner from 'Components/Spinner/Spinner';
import { Content } from 'Constants/styles';
import React, { MouseEvent, useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { useParams } from 'react-router-dom';
import getErrorMessage from 'utils/getErrorMessage';

import CheckoutLimits from './CheckoutLimits';
import GeneralSettings from './GeneralSettings';
import PaymentPlanLimits from './PaymentPlanLimits';
import PayoutSettings from './PayoutSettings';
import VelocityLimits from './VelocityLimits';
import { SpinnerWrapper } from './styles';

const MerchantSettings = () => {
  const { merchantId } = useParams<{ merchantId: string }>();

  const { apiAprilBaseUri } = useSelector((state: ReduxStateType) => ({
    apiAprilBaseUri: state.apiAprilBaseUri,
  }));

  const [merchantGeneralSettings, setMerchantgeneralSettings] = useState<MerchantGeneralSettingsResponse | null>(null);
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const [errorMsg, setErrorMsg] = useState<string>('');

  const handleCloseMsg = (e: MouseEvent<HTMLButtonElement>): void => {
    e.preventDefault();
    setErrorMsg('');
  };

  useEffect(() => {
    if (!apiAprilBaseUri || !merchantId) {
      return;
    }

    const fetchGeneralSettings = async () => {
      try {
        setIsLoading(true);
        setErrorMsg('');
        const merchantResp = await getMerchantGeneralSettings(apiAprilBaseUri, merchantId);
        setMerchantgeneralSettings(merchantResp);
      } catch (e) {
        setErrorMsg(getErrorMessage(e));
      } finally {
        setIsLoading(false);
      }
    };

    fetchGeneralSettings();
  }, [apiAprilBaseUri, merchantId]);

  return (
    <>
      <HeaderTile title="Merchant Settings" />
      <Content className="merchant-details-content">
        {isLoading && (
          <SpinnerWrapper>
            <Spinner color="#0016D1" />
          </SpinnerWrapper>
        )}
        {!isLoading && errorMsg.length > 0 && (
          <Message className="mt-2 mb-0" description={errorMsg} success={false} handleClose={handleCloseMsg} />
        )}
        <>
          <GeneralSettings merchantId={merchantId} />
          <PayoutSettings merchantId={merchantId} />
          <PaymentPlanLimits merchantId={merchantId} />
          <CheckoutLimits merchantId={merchantId} />
          <VelocityLimits
            merchantId={merchantId}
            initMerchantVelocityConfig={merchantGeneralSettings?.velocityConfig}
          />
        </>
      </Content>
    </>
  );
};

export default MerchantSettings;
